import React, { useEffect, useState } from 'react'
import { useNavigate } from 'react-router-dom'
import { getThemeColors, THEME_OPTIONS } from '../theme'
import Header from './Header'
import Footer from './Footer'

const FEEDBACK_EMAIL = 'feedback@cuneo.pro'
const CONTACT_EMAIL = 'contacto@cuneo.pro'

export default function Feedback({ theme = THEME_OPTIONS.LIGHT, session = null }) {
  const C = getThemeColors(theme)
  const navigate = useNavigate()
  const [isMobile, setIsMobile] = useState(() => (typeof window !== 'undefined' ? window.innerWidth <= 900 : false))

  useEffect(() => {
    const onResize = () => setIsMobile(window.innerWidth <= 900)
    window.addEventListener('resize', onResize)
    return () => window.removeEventListener('resize', onResize)
  }, [])

  const cardStyle = {
    background: C.white,
    border: `0.5px solid ${C.border}`,
    borderRadius: '18px',
    padding: '24px',
    boxShadow: C.shadow,
    display: 'flex',
    flexDirection: 'column',
    gap: '14px',
  }

  const pillStyle = () => ({
    display: 'inline-flex',
    alignItems: 'center',
    justifyContent: 'center',
    alignSelf: 'flex-start',
    padding: '9px 16px',
    borderRadius: '999px',
    border: `0.5px solid ${C.border}`,
    background: C.white,
    color: C.muted,
    fontSize: '12px',
    fontWeight: '500',
  })

  const emailBoxStyle = {
    background: C.blueLight,
    color: C.blue,
    borderRadius: '14px',
    padding: '16px 18px',
  }

  const buttonStyle = {
    display: 'inline-flex',
    alignItems: 'center',
    justifyContent: 'center',
    alignSelf: 'center',
    marginTop: '2px',
    padding: '12px 18px',
    background: C.blue,
    color: '#fff',
    borderRadius: '10px',
    textDecoration: 'none',
    fontSize: '13px',
    fontWeight: '500',
  }

  return (
    <div style={{ minHeight: '100vh', background: C.bg, color: C.text, fontFamily: "'DM Sans', system-ui, sans-serif", overflowX: 'hidden' }}>
      <Header theme={theme} session={session} perfil={null} />

      <div style={{ maxWidth: '1080px', margin: '0 auto', padding: isMobile ? '16px' : '32px', boxSizing: 'border-box' }}>
        <div style={{ marginBottom: '28px' }}>
          <div style={{ fontSize: isMobile ? '24px' : '30px', fontWeight: '500', letterSpacing: '-0.8px' }}>Feedback y contacto</div>
          {session && (
            <button
              onClick={() => navigate('/dashboard')}
              style={{ marginTop: '12px', padding: '8px 12px', background: C.blueLight, color: C.blue, border: `0.5px solid ${C.border}`, borderRadius: '8px', cursor: 'pointer', fontSize: '12px', fontWeight: '500' }}
            >
              Volver al dashboard
            </button>
          )}
        </div>

        <div style={{ display: 'grid', gridTemplateColumns: isMobile ? '1fr' : '1fr 1fr', gap: '18px', alignItems: 'start', marginBottom: '18px' }}>
          <div style={cardStyle}>
            <div style={pillStyle()}>Feedback de producto</div>
            <div style={{ fontSize: '18px', fontWeight: '500', lineHeight: '1.3' }}>Cuéntanos cómo va tu experiencia</div>
            <div style={{ fontSize: '13px', color: C.muted, lineHeight: '1.8' }}>
              Úsalo para ideas, bugs, confusión de producto o mejoras que te gustaría ver en JobPipeline.
            </div>

            <div style={emailBoxStyle}>
              <div style={{ fontSize: '12px', fontWeight: '600', textTransform: 'uppercase', letterSpacing: '0.06em', marginBottom: '6px' }}>
                Correo
              </div>
              <div style={{ fontSize: '22px', fontWeight: '600', letterSpacing: '-0.4px', wordBreak: 'break-word' }}>
                {FEEDBACK_EMAIL}
              </div>
            </div>

            <div style={{ fontSize: '13px', color: C.muted, lineHeight: '1.8' }}>
              En tu correo, cuéntanos brevemente qué intentabas hacer, qué esperabas que pasara y qué pasó realmente.
            </div>

            <a href={`mailto:${encodeURIComponent(FEEDBACK_EMAIL)}`} style={buttonStyle}>
              Abrir correo y enviar
            </a>
          </div>

          <div style={cardStyle}>
            <div style={pillStyle()}>Contacto general</div>
            <div style={{ fontSize: '18px', fontWeight: '500', lineHeight: '1.3' }}>Escríbenos por cualquier otro asunto</div>
            <div style={{ fontSize: '13px', color: C.muted, lineHeight: '1.8' }}>
              Úsalo para alianzas, soporte general, dudas comerciales o cualquier tema que no sea feedback del producto.
            </div>

            <div style={emailBoxStyle}>
              <div style={{ fontSize: '12px', fontWeight: '600', textTransform: 'uppercase', letterSpacing: '0.06em', marginBottom: '6px' }}>
                Correo
              </div>
              <div style={{ fontSize: '22px', fontWeight: '600', letterSpacing: '-0.4px', wordBreak: 'break-word' }}>
                {CONTACT_EMAIL}
              </div>
            </div>

            <div style={{ fontSize: '13px', color: C.muted, lineHeight: '1.8' }}>
              En tu correo, cuéntanos el motivo de tu contacto y cualquier contexto útil para ayudarte más rápido.
            </div>

            <a href={`mailto:${encodeURIComponent(CONTACT_EMAIL)}`} style={buttonStyle}>
              Abrir correo y enviar
            </a>
          </div>
        </div>

        <div style={{ maxWidth: '420px', paddingTop: '6px' }}>
          <div style={{ fontSize: '16px', fontWeight: '500', marginBottom: '8px' }}>Qué incluir</div>
          <ul style={{ margin: 0, paddingLeft: '18px', color: C.muted, fontSize: '13px', lineHeight: '1.9' }}>
            <li>Qué intentabas hacer</li>
            <li>Qué esperabas que pasara</li>
            <li>Qué pasó realmente</li>
            <li>Si aplica, screenshots o pasos para reproducirlo</li>
          </ul>
        </div>

        <Footer theme={theme} />
      </div>
    </div>
  )
}
